export const CHEATING_TYPE = {
	COPY_PASTE: 'Copy & Paste',
	SWITCHING_TAB: 'Switching Tab',
};
